module.exports = __webpack_public_path__ + "static/customerbg1-ff179aa9cfafeff6fff4f59ca8c591e3.jpg";